// extracted by mini-css-extract-plugin
export default {"container":"filterRegion_container__t0EFA","arrow":"filterRegion_arrow__S7vsc","regions":"filterRegion_regions__E709X","region":"filterRegion_region__7gi3p"};